import { useQuery } from '@tanstack/react-query'

import { FeedbackType } from '@/core/api/entities/song/feedbackType'
import { FeedbackTypeMapper } from '@/core/api/mappers/song/feedbackTypeMapper'
import feedbackService from '@/core/api/services/feedbackService'

export const useFeedbackTypes = () => {
	return useQuery<FeedbackType[], Error>({
		queryKey: ['feedback-types'],
		queryFn: () =>
			feedbackService.getFeedbackTypes().then(({ data }) => {
				return FeedbackTypeMapper.toEntities(data.data)
			}),
	})
}
